import { render, staticRenderFns } from "./VideoWithSwiper.vue?vue&type=template&id=110a670e&scoped=true&"
import script from "./VideoWithSwiper.vue?vue&type=script&lang=js&"
export * from "./VideoWithSwiper.vue?vue&type=script&lang=js&"
import style0 from "./VideoWithSwiper.vue?vue&type=style&index=0&id=110a670e&prod&lang=postcss&scoped=true&"
import style1 from "./VideoWithSwiper.vue?vue&type=style&index=1&id=110a670e&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a670e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsEmbed: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsEmbed.vue').default,SwiperNav: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/swiper-nav/SwiperNav.vue').default})
